import SchedulesPage from "./SchedulesPage";

export default function SchedulesShopsPage() {
  return <SchedulesPage view="coverage" />;
}
